















































































































































import { Component, Vue } from "vue-property-decorator";
import { State, Action } from "vuex-class";
import _ from "lodash";
import GlobalMixins from "@/global.mixin";
import {importExportApi} from "../../../services/api/importexport.api";
import { costCentersApi } from "../../../services/api/costCenters.api";
import LoadingPopup from "@/components/LoadingPopup.vue";

@Component({
  mixins: [GlobalMixins],
  components: { LoadingPopup }
})
export default class CostCenters extends Vue {
  @State("costCenters") costCentersState: any;

  @Action("getCostCenters") getCostCenters: any;
  @Action("saveCostCenter") saveCostCenter: any;
  @Action("deleteCostCenter") deleteCostCenter: any;

  snacktext = "";
  loader = false;
  search = "";

  formValid = false;

  editingDialog = false;
  isNewCostCenter = false;
  defaultItem = {
    costCenterId: 0,
    name: "",
    description: "",
  };
  editedItem = Object.assign({}, this.defaultItem);
  editedIndex = -1;

  // Upload related properties
  uploadDialog = false;
  uploadDialogTitle = "";
  uploadDialogText = "";
  loading = false;

  rowsPerPageItems = [10, 25, 50, 100, 200, { text: "All", value: -1 }];

  pagination = {
    sortBy: "name",
    descending: false,
    page: 1,
    rowsPerPage: this.$cookies.isKey("costCenters-rowsPerPage") ?
                        parseInt(this.$cookies.get("costCenters-rowsPerPage"), 10) : 25
  };

  serversideSearch = _.debounce(() => {
    this.updatePagination(this.pagination);
  }, 300);

  getHeaders() { return [
    { text: "#", value: "costCenterId", width: "1%", align: "left", sortable: true},
    { text: this.$t("COST_CENTERS_TABLE_HEADER_NAME"), value: "name", width: "1%", align: "left", sortable: true },
    { text: this.$t("COST_CENTERS_TABLE_HEADER_DESCRIPTION"), value: "description", width: "1%", align: "left", sortable: true },
    { text: this.$t("TABLE_ACTIONS"), value: "", sortable: false,  }
  ];
  }
  async created() {
    // -
  }

  reload() {
    this.updatePagination(this.pagination);
  }

  changeSort(column, sortable) {
    if (!sortable) {
      return;
    }

    if (this.pagination.sortBy === column) {
      this.pagination.descending = !this.pagination.descending;
    } else {
      this.pagination.sortBy = column;
      this.pagination.descending = false;
    }
    this.updatePagination(this.pagination);
  }

  updatePagination(pagination) {
    this.$cookies.set("costCenters-rowsPerPage", pagination.rowsPerPage);

    const searchexpression = this.search.trim();
    const x = searchexpression.split(" ");
    const page = {
      sortBy: pagination.sortBy,
      descending: pagination.descending,
      page: pagination.page,
      rowsPerPage: pagination.rowsPerPage,
      searchString: x,
    };
    this.getCostCenters(page);
  }

  save() {
    if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {

      this.saveCostCenter({
        data: JSON.stringify(this.editedItem),
        index: this.editedIndex
      })
      .then(res => {
        this.close();
      })
      .catch(res => {
        // handle....
        // this.close();
      });
    }
  }

  close() {
    this.editingDialog = false;
    this.editedItem = Object.assign({}, this.defaultItem);
    this.editedIndex = -1;
    if (this.$refs.form) {
      // this.$refs.form.resetValidation();
      (this.$refs.form as Vue & { resetValidation: () => void }).resetValidation();
    }
  }

  editItem(item) {
    this.isNewCostCenter = false;
    this.editedIndex = this.costCentersState.costCenters.indexOf(item);
    this.editedItem = Object.assign({}, item);

    this.editingDialog = true;
  }

  deleteItem(item) {
    const index = this.costCentersState.costCenters.indexOf(item);

    if (confirm(this.$t("COST_CENTER_DELETE_CONFIRM") as string)) {
      this.deleteCostCenter({ id: item.costCenterId, index });
    }
  }

  // Download methods
  downloadCostCentersData() {
    importExportApi.downloadCostCenterExport({}, "koltseghely-export.xlsx");
  }

  // Upload methods
  onPickFile() {
    (this.$refs.fileInput as HTMLInputElement).click();
  }

  selectFile(event) {
    const file = event.target.files[0];

    if (!file) {
      return;
    }

    this.loading = true;

    costCentersApi.upload(file)
      .then(res => {
        if (res.data.status === 1) {
          // success
          this.uploadDialogTitle = "Sikeres betöltés!";
          this.uploadDialogText = res.data.msg;
        } else if (res.data.status === 3) {
          // validation errors
          this.uploadDialogTitle = "Érvénytelen adat!";
          this.uploadDialogText = res.data.errors.join("<br>");
        } else {
          this.uploadDialogTitle = "Hiba";
          this.uploadDialogText = res.data.msg || "Ismeretlen hiba történt";
        }
        this.loading = false;
        this.uploadDialog = true;

        // Refresh the data after successful upload
        if (res.data.status === 1) {
          this.updatePagination(this.pagination);
        }
      })
      .catch(error => {
        this.loading = false;

        this.uploadDialogTitle = "Váratlan Válasz!";
        this.uploadDialogText = JSON.stringify(error);
        this.uploadDialog = true;
        console.error("A feltöltés nem sikerült:", error);
      });

    // Clear the file input so the same file can be selected again
    event.target.value = "";
  }
}
